import { atomWithStorage } from "jotai/utils";

export const openGroupsAtom = atomWithStorage<Record<string, boolean>>(
    "openGroups",
    { settings: false },
);
